import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";
import axios from "axios";

import Positions from "./Positions";
import Add from "./Add";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result.map((item, index) => {
    item.priority = index;
    return item;
  });
};

class UserPositions extends React.Component {
  state = {
    positions: this.props.positions
  };

  static url(id = null) {
    return `${window.location.pathname}${id ? `/${id}` : ""}`;
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-2 col-md-offset-8 col-sm-3 col-sm-offset-6 col-xs-6">
            <div className="pull-right">
              <button
                className="btn btn-indigo btn-raised btn-long"
                onClick={this.handlerAddAll}
                disabled={this.disableButtons()}
                title={this.disableButtons() ? "All available positions have been added" : ""}
              >
                ADD ALL
              </button>
            </div>
          </div>
          <div className="col-md-2 col-sm-3 col-xs-6">
            <div className="pull-right">
              <Add
                onClick={this.handlerAdd}
                disabled={this.disableButtons()}
                title={this.disableButtons() ? "All available positions have been added" : ""}
              />
            </div>
          </div>
        </div>
        <br />

        <div className="row">
          <div className="col-md-12">
            <Positions
              data={this.state.positions}
              allPositions={this.props.allPositions}
              onDelete={this.handlerDelete}
              onSave={this.handlerSave}
              onRemove={this.handlerRemove}
              onDragEnd={this.handlerDragEnd}
            />
          </div>
        </div>
      </div>
    );
  }

  disableButtons = () => {
    return this.state.positions.length >= this.props.allPositions.length;
  };

  handlerDragEnd = (result) => {
    if (
      !result.destination ||
      result.destination.index === result.source.index
    ) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }

    const positions = reorder(
      this.state.positions,
      result.source.index,
      result.destination.index
    );

    this.setState({ positions }, this.updatePriorities);
  };

  handlerAddAll = () => {
    axios
      .post(`${window.location.pathname}/create_all`)
      .then((response) => {
        let newPositions = this.state.positions;
        newPositions = newPositions.concat(response.data);
        newPositions = newPositions.filter(position => position.id !== null);
        this.setState({ positions: newPositions });
        toastr.success("All positions added");
      })
      .catch(() => toastr.error("Something went wrong, please contact support."));
  };

  handlerAdd = () => {
    this.setState({
      positions: this.state.positions.concat({
        _id: -new Date().getTime(),
        id: null,
        priority: Math.max(...this.state.positions.map(p => p.priority)) + 1,
        positionId: null,
        hourlyRate: "0.00",
        code: "",
      }),
    });
  };

  handlerRemove = (_id) => {
    const positions = lodash.filter(this.state.positions, (p) => p._id !== _id);
    this.setState({ positions });
  };

  handlerDelete = (id) => {
    const positions = lodash.filter(this.state.positions, (p) => p.id !== id);
    this.setState({ positions });

    axios
      .delete(UserPositions.url(id))
      .then(() => {
        toastr.success("Position removed");
      })
      .catch(() => {
        toastr.error("There was an error, please refresh the page.");
      });
  };

  handlerSave = (id, dataPositions, callback) => {
    if (id) {
      this.update(id, dataPositions, callback);
    } else {
      this.create(dataPositions, callback);
    }
  };

  updatePriorities = () => {
    const data = this.state.positions
      .filter((p) => p.id)
      .map((p) => ({ id: p.id, priority: p.priority }));
    axios
      .put(UserPositions.url("priorities"), { data: data })
      .then(() => {
        toastr.success("Position updated");
      })
      .catch(() => {
        toastr.error("There was an error, please refresh the page.");
      });
  };

  update = (id, dataPosition, callback) => {
    axios
      .put(UserPositions.url(id), dataPosition)
      .then(({ data }) => {
        const idx = lodash.findIndex(this.state.positions, { id: id });
        let positions = this.state.positions;
        positions[idx] = data;
        positions = positions.filter(position => position.id !== null);

        this.setState({ positions }, () => {
          if (callback) {
            callback(true);
          }
        });
        toastr.success("Position updated");
      })
      .catch(() => {
        if (callback) {
          callback(false);
        }
        toastr.error("There was an error, please refresh the page.");
      });
  };

  create = (dataPosition, callback) => {
    axios
      .post(UserPositions.url(), dataPosition)
      .then(({ data }) => {
        const idx = lodash.findIndex(this.state.positions, {
          _id: dataPosition._id,
        });
        let positions = this.state.positions;
        positions[idx] = data;
        positions = positions.filter(position => position.id !== null);

        this.setState({ positions }, () => {
          if (callback) {
            callback(true);
          }
        });
        toastr.success("Position added");
      })
      .catch(({ response }) => {
        if (callback) {
          callback(false);
        }
        toastr.error("There was an error, please refresh the page.");
      });
  };
}

UserPositions.propTypes = {
  positions: PropTypes.array.isRequired,
  allPositions: PropTypes.array,
};

export default UserPositions;
